import { h } from "preact";

import IconProps from "./IconProps";

function IconSlack({
    class: cssClass,
    color
}: IconProps) {
    const getFillColor = (defaultColor: string) => color ?? `var(--icon-color, ${defaultColor})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={getFillColor("#E01E5A")} d="M3.362 10.11c0 .926-.756 1.681-1.681 1.681S0 11.036 0 10.111C0 9.186.756 8.43 1.68 8.43h1.682v1.68zM4.208 10.11c0-.924.756-1.68 1.681-1.68s1.681.756 1.681 1.68v4.21c0 .924-.756 1.68-1.68 1.68-.926 0-1.682-.756-1.682-1.68v-4.21z"/>
            <path fill={getFillColor("#36C5F0")} d="M5.89 3.362c-.926 0-1.682-.756-1.682-1.681S4.964 0 5.89 0 7.57.756 7.57 1.68v1.682H5.89zM5.89 4.208c.924 0 1.68.756 1.68 1.681S6.814 7.57 5.89 7.57H1.68C.757 7.57 0 6.814 0 5.89c0-.926.756-1.681 1.68-1.681h4.21z"/>
            <path fill={getFillColor("#2EB67D")} d="M12.638 5.89c0-.926.756-1.681 1.681-1.681S16 4.963 16 5.888c0 .925-.756 1.681-1.68 1.681h-1.682V5.89zM11.792 5.89c0 .924-.756 1.68-1.681 1.68S8.43 6.814 8.43 5.89V1.68C8.43.757 9.186 0 10.11 0c.926 0 1.682.756 1.682 1.68v4.21z"/>
            <path fill={getFillColor("#ECB22E")} d="M10.11 12.638c.926 0 1.682.756 1.682 1.681S11.036 16 10.11 16s-1.681-.756-1.681-1.68v-1.682h1.68zM10.11 11.791c-.924 0-1.68-.755-1.68-1.68 0-.925.756-1.681 1.68-1.681h4.21c.924 0 1.68.756 1.68 1.68 0 .926-.756 1.681-1.68 1.681h-4.21z"/>
        </svg>
    );
}

export default IconSlack;
